export enum LocalStorageKeys {
    SearchFilters = 'search-filters'
}
